export const HOUSES_PER_PAGE = 25;
export const HOUSE_VIEWS = {
  topMatches: 'topMatches',
  favorites: 'favorites',
  recently: 'recently',
}
